import styled from "styled-components";
import React from 'react';

const Select = styled.select`
  padding: 15px 13px;
  background-color: #fff;
  border: 1px solid ${props => props.error ? '#FC766A' : '#E9E9E9'};
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  box-shadow: 0 4px 32px 0 #00000012;
  font-size: 15px;
  font-weight: 400;
  width: 100%;
  color: #605D5C;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url("http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png") no-repeat 60px center;
  background-position: 97% 50%;

  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0 2px 1px;
  }
`;

const ErrorMessage = styled.div`
  color: #FC766A;
  font-size: 13px;
  margin-top: 10px;
  font-family: "Roboto", sans-serif;
`

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const SimpleSelect = ({options, onChange, error, validationError}) => {
    const errorMessage = validationError ? "Field value is not valid" : "This field is required"
    const handleSelect = (e) => {
        if (e.target.value !== "How did you hear about us?") {
            onChange(e.target.value)
        }
    }
    return (
        <SelectWrapper>
            <Select onInput={(e) => handleSelect(e)} required error={error}>
                {options.map(option => {
                    return <option value={option} key={option}>{option}</option>
                })}
            </Select>
            {(error || validationError) && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </SelectWrapper>
    )
}

export default SimpleSelect
